export const APP_ROUTES = {
  login: '/login',
  home: '/',
  candidates: {
    list: '/candidates',
    create: '/candidates/new',
    orphaned: '/candidates/orphaned',
    detail: (idOrReference: string) => `/candidates/${idOrReference}`,
    edit: (id: string) => `/candidates/${id}/edit`,
  },
  employees: {
    list: '/employees',
    detail: (reference: string) => `/employees/${reference}`,
  },
  directNda: {
    list: '/direct-nda',
    detail: (id: string) => `/direct-nda/${id}`,
  },
  portal: '/portal',
} as const;
